export default __webpack_public_path__ + "static/media/more-services-2.ea502d1b.svg";